var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlaceholder = function SvgIconPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.164 4.75 19.25 17.836V4.75zm14.451 16.099a1 1 0 0 0 .234-.234c.25-.303.401-.691.401-1.115v-15a1.75 1.75 0 0 0-1.75-1.75h-15c-.425 0-.814.151-1.117.403a1 1 0 0 0-.23.23A1.74 1.74 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15c.424 0 .813-.15 1.115-.401m-2.779-1.599L4.75 6.164V19.25z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPlaceholder;